import { FieldValue } from "../../features/ui"
import { DynamoUserApi } from "../../services"
import { AttributeMap, useDynamoActions } from "../../services/dynamo"
import { DataType, TableName, TablesData } from "../../tables"
import { define } from "../../utils/typeUtils"

export const useAddedRequiredPropMigration = () => {
    const dynamoActions = useDynamoActions()

    return (
        companyIds: string[],
        table: TableName,
        propName: string,
        defaultValue: (dataType: DataType) => FieldValue | FieldValue[]
    ) => {
        companyIds.forEach(async companyId => {
            const { getAll, createOrUpdate } = dynamoActions(DynamoUserApi, companyId)
            const { dbTableName } = define(TablesData.get(table))

            const dataTypes = await getAll(dbTableName) as DataType[]
            const updatedDataTypes: AttributeMap[] = []
            dataTypes.forEach(dataType => {
                if (!dataType.hasOwnProperty(propName)) {
                    const newVaue = defaultValue(dataType)
                    const updatedDataType = {
                        ...dataType,
                        [propName]: newVaue
                    } as AttributeMap
                    updatedDataTypes.push(updatedDataType)
                }
            })

            await createOrUpdate(dbTableName, updatedDataTypes)
        })
    }
}
